<template>
  <v-tooltip :text="$t('deleteAction')" location="top">
    <template v-slot:activator="{ props }">
      <v-icon v-bind="props" @click="actionOpen" data-qa="delete-action" >delete</v-icon>
    </template>
  </v-tooltip>
</template>

<script lang="ts">
import ModalEnum from '../../constant/ModalEnum';
import { modalSimpleStore } from '../../stores/modal';

export default {
  emits: ['actionDeleted','actionDeleteOpen','cancelClicked'],
  props: {
    id: String,
    name: String,
  },
  methods: {
    actionOpen() {
      this.$emit('actionDeleteOpen', this.$props.id);
      modalSimpleStore.showModal({
        id: ModalEnum.CONFIRMED_MODAL,
        maxWidth: 500,
        title: this.$t('deleteAction'),
        message: this.$t('actionWillBeDeleted', {actionName: this.$props.name}),
        onSuccess: async () => {
          try {
            this.$emit('actionDeleted', this.$props.id)
          } catch (error) {
            modalSimpleStore.showModal({
              id: ModalEnum.ERROR_MODAL,
              title: "Error!",
              message: this.$t("actionDeletionFailed"),
              error: error,
            });
          } finally {
            modalSimpleStore.hideModal(ModalEnum.CONFIRMED_MODAL);
            modalSimpleStore.showModal({
              id: ModalEnum.SUCCESS_MODAL,
              title: "Success!",
              message: this.$t("actionDeleted"),
            });
            return;
          }
        },
        onCancel: async () => {
          this.$emit('cancelClicked', this.$props.id);
        },
        onClose: async () => {
          return modalSimpleStore.hideModal(ModalEnum.CONFIRMED_MODAL);
        },
      });
    }
  }
}
</script>